/// <amd-module name="Wit/DeliveryPlans/Common/Utils/RoutingUtils" />
import { getTFSPageData } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";

const planTimelineRoute = "ms.vss-work-web.delivery-plans-timeline-route";
const backlogRoute = "ms.vss-work-web.backlogs-content-route";
const sprintsRoute = "ms.vss-work-web.sprints-content-route";
const workItemFormRoute = "ms.vss-work-web.work-items-form-route";

export function getPlanUrl(pageContext: IVssPageContext, planId: string): string {
    const projectName = getTFSPageData(pageContext)?.project?.name;
    const routeValues = {
        project: projectName || "",
        plan: planId
    };

    return routeUrl(pageContext, planTimelineRoute, routeValues);
}

export function getBacklogUrl(pageContext: IVssPageContext, projectId: string, teamName: string, backlogLevel: string) {
    const routeValues = {
        backlogLevel,
        pivot: "backlog",
        project: projectId,
        teamName
    };

    return routeUrl(pageContext, backlogRoute, routeValues);
}

export function getWorkItemUrl(pageContext: IVssPageContext, workItemId: string, projectId: string) {
    const routeValues = {
        id: workItemId,
        project: projectId
    };

    return routeUrl(pageContext, workItemFormRoute, routeValues);
}

export function getSprintHubUrl(pageContext: IVssPageContext, project: string, teamName: string, iteration: string) {
    const routeValues = {
        iteration,
        pivot: "taskboard",
        project,
        teamName
    };

    return routeUrl(pageContext, sprintsRoute, routeValues);
}
